import React, {Component} from 'react'
import BitmapShape from "../types/BitmapShape";

interface Props {
    data: BitmapShape
}

class BitmapSvg extends Component<Props> {
    render() {
        const data : BitmapShape = this.props.data
        const isShadow = data.shadow_color && data.shadow_sigma

        return (
            <g className="draggable">
                {isShadow &&
                <filter id={`shadow-${data.index}`} width="200%" height="200%" y="-50%" x="-50%">
                    <feDropShadow
                        dx={data.shadow_xoffset}
                        dy={data.shadow_yoffset}
                        stdDeviation={data.shadow_sigma}
                        floodColor={data.shadow_color}
                        floodOpacity={1-data.shadow_opacity/100}
                    />
                </filter>
                }

                {data.stroke_width && data.stroke_width > 0 && data.stroke_color &&
                <rect
                    width={data.width+data.stroke_width}
                    height={data.height+data.stroke_width}
                    transform={`translate(${-data.width/2-data.stroke_width/2},${-data.height/2-data.stroke_width/2})`}
                    stroke={data.stroke_color}
                    fill="transparent"
                    strokeWidth={data.stroke_width}
                />
                }
                <image
                    id={`${data.index}-bitmap`}
                    width={data.width}
                    height={data.height}
                    preserveAspectRatio={data.is_aspect_size_ratio ? 'xMidYMid meet' : 'none'}
                    transform={`translate(${-data.width/2},${-data.height/2})`}
                    filter={isShadow ? `url(#shadow-${data.index}` : ''}
                    xlinkHref={data.imageBlob}
                />
            </g>
        )
    }
}

export default BitmapSvg
